import React from 'react';

export const IcoMenu: React.FC = (props) => (
  <svg width="22" height="16" viewBox="0 0 22 16" fill="none" {...props}>
    <rect width="16" height="2" rx="1" fill="currentColor" />
    <rect y="14" width="16" height="2" rx="1" fill="currentColor" />
    <rect y="7" width="22" height="2" rx="1" fill="CurrentColor" />
  </svg>
);
